//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["blok"],
  data() {
    return {
      showBanner: true,
    };
  },
};
